<script>
import { BModal, BFormGroup, BFormTextarea, } from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import Overlay from "@core/components/common/Overlay.vue";

export default {
    components: {Overlay, BModal, BFormGroup, BFormTextarea, flatPickr},
    props: {
        record: {
            type: Object,
            default() {
                return {
                    note: '',
                    attributes: {
                        dateTime: new Date()
                    }
                };
            }
        }
    },
    data() {
        return {
            note: this.record ? this.record.note : '',
            dateTime: this.record ? this.record.attributes.dateTime : new Date(),

            dateTimePickerConfig: {
                time_24hr: true,
                allowInput: true,
                enableTime: true,
                dateFormat: this.$store.state.component.dateTimePicker.format
            },

            showLoading: false
        };
    },
    methods: {
        show(clear = false) {
            this.showLoading = false;
            this.$refs.noteModal.show();

            if (clear) {
                this.dateTime = null;
                this.note = '';
            }

            if (null === this.dateTime) {
                this.dateTime = new Date();
            }
        },
        emit(e) {
            e.preventDefault();

            this.showLoading = true;
            this.$emit('save', {
                note: this.note,
                dateTime: this.dateTime
            }, this.record, () => {
                //  success
                this.showLoading = false;
                this.clear();
                this.$refs.noteModal.hide();
            }, () => {
                //  error
                this.showLoading = false;
            });
        },
        clear() {
            this.note = '';
            this.dateTime = null;
        }
    },
    watch: {
        record() {
            if (this.record) {
                this.note = this.record.note;
                this.dateTime = this.record.attributes.dateTime;
            }
        },
    }
}
</script>

<template>
    <b-modal
        ref="noteModal"
        cancel-variant="outline-secondary"
        :ok-title="$t('Component(Button):save')"
        :title="$t('Page(FollowUp):Component(NoteModal):label')"
        @ok="emit"
        :ok-disabled="showLoading"
        size="lg"
        :cancel-title="$t('Component(Button):close')"
        centered
        no-close-on-backdrop
    >
        <Overlay :show="showLoading">
            <b-form-group
                :label="$t('Component(Label):date')"
                label-for="date"
            >
                <flat-pickr
                    name="date"
                    v-model="dateTime"
                    class="form-control"
                    :config="dateTimePickerConfig"
                />
            </b-form-group>

            <b-form-group
                :label="$t('Component(Grid):column-follow-up-note')"
                label-for="note"
            >
                <b-form-textarea rows="3" max-rows="6" v-model="note" />
            </b-form-group>
        </Overlay>
    </b-modal>
</template>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
